import { AddressChoiceAction, AddressChoiceNavigator } from '@/setting/stores/addressChoice/address-choice-navigator';
import { BfAppContext, BfIntentResultType, fileSizeFormat, promiseWait } from '@tw/tw-runtime';
import { BfPageStoreProvider, useStoreState } from '@tw/tw-runtime-react';
import { Center, Circle, Divider } from 'native-base';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import React, { useState } from 'react';
import { ScrollView, Text, View } from 'react-native';
import { TwColumn, TwIcon, TwListItem, TwListItemContent, TwPage, TwRow } from '@tw/tw-components-rn';

import { CommonStore } from '@/app/core/store/common/common-store';
import { ElementUtils } from '@tw/tw-platform-react';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { TwButton } from '@/app/components/tw-button/TwButton';
import { TwSpacer } from '@tw/tw-components-rn';
import { TwTcCommodityCardInfo } from '@tw/tw-templates-rn';
import { styles } from './styles';
import { useMount } from 'react-use';

export const GiftGiftConfirmOrder = () => {
  const [store] = useState(CommonStore.getInstance());

  const selectedGoods = useStoreState(store, (state) => state.selectedGoods);
  const address = useStoreState(store, (state) => state.address);
  const selectedGoodsAmount = useStoreState(store, (state) => state.selectedGoodsAmount) ?? 0;

  useMount(() => {
    store.getAddress();
  });

  return (
    <BfPageStoreProvider store={store}>
      <TwPage
        translucentStatusBar={true}
        style={styles.container}
        footer={
          <View style={styles.commandContainer}>
            <TwRow space={2}>
              <TwButton
                style={styles.button}
                onPress={async () => {
                  const confirm = await BfAppContext.getInstance()
                    .getMessageService()
                    .showConfirm('确认要修改订单吗？');

                  if (!confirm) {
                    return;
                  }
                  BfAppContext.getInstance().getRouteService().back();
                }}
                shape={'round'}
                variant={'outline'}
              >
                修改订单
              </TwButton>
              <TwButton style={styles.button} onPress={() => store.onOrderConfirmClick()} shape={'round'}>
                提交订单
              </TwButton>
            </TwRow>
          </View>
        }
      >
        <ScrollView style={{ height: '100%' }}>
          <TwColumn space={2}>
            <TwListItem
              style={styles.addressContainer}
              icon={
                <Circle style={styles.iconContainer}>
                  <TwIcon icon={'icon-location'} size={24} color={'#565656'}></TwIcon>
                </Circle>
              }
              content={
                <TwListItemContent
                  title={ElementUtils.getText(address, { type: 'coordinates', id: 'address' })}
                  // subTitle={address?.isDef ? <Text style={styles.contentTitle}>默认</Text> : null}
                  content={
                    <TwRow space={2} alignItems={'center'}>
                      <Text style={styles.contentDesc}>{address?.linkmanName}</Text>
                      <Text style={styles.contentDesc}>{address?.linkmanMobile}</Text>
                    </TwRow>
                  }
                />
              }
              showArrow={true}
              pressable={true}
              onPress={async () => {
                const res = await AddressChoiceNavigator.start({
                  action: AddressChoiceAction.selectAddress,
                  selectedAddressId: address?.id
                });
                if (res.type === BfIntentResultType.OK && res.data) {
                  store.setAddress(res.data);
                }
              }}
            ></TwListItem>

            <TwColumn space={2} style={styles.contentContainer}>
              <TwRow style={styles.contentHeader}>
                <Text style={styles.headerTitle}>我的订单</Text>
                <TouchableOpacity
                  onPress={async () => {
                    store.clearCart(true);
                  }}
                >
                  <TwRow space={1} alignItems={'center'}>
                    <TwIcon icon={'icon-delete-one'} size={16} color={'#8FBD69'}></TwIcon>
                    <Text style={styles.headerButton}>清空</Text>
                  </TwRow>
                </TouchableOpacity>
              </TwRow>
              <Divider></Divider>
              {selectedGoods.map((item, index) => {
                return (
                  <TwTcCommodityCardInfo
                    key={index}
                    title={item.good.name}
                    subTitle={item.good.desc}
                    price={item.good.price}
                    num={item.count}
                    imageUrl={item.good?.showPicture?.url}
                    onPress={() => store.onGoodClick(item.good, 'view')}
                  />
                );
              })}
              <Divider></Divider>
              <TwRow space={2} style={styles.contentFooter}>
                <Text style={styles.commodityNumber}>{`共${store.getSelectedGoodCount()}件商品`}</Text>
                <TwRow alignItems={'center'} space={2}>
                  <Text style={styles.priceTitle}>总计</Text>
                  <TwRow alignItems={'center'}>
                    <Text style={styles.priceSymbol}>¥</Text>
                    <Text style={styles.price}>{selectedGoodsAmount}</Text>
                  </TwRow>
                </TwRow>
              </TwRow>
            </TwColumn>
          </TwColumn>
        </ScrollView>
      </TwPage>
    </BfPageStoreProvider>
  );
};
